import { absolutePath } from "./absolutePath";

interface ChatSpacesFnProps {
  id?: string | number;
  params?: Record<string, unknown>;
}

export const chatSpaces = {
  transcript: ({ id, params = {} }: ChatSpacesFnProps = {}) =>
    absolutePath(`chat_spaces/${id}/transcript`, params),
};
